import React from 'react';
import {UsysUtilityPageConstraint, setDisplayNone} from '../utils';
import {
  USYS_DATA_ATTRS,
  USYS_FORM_TYPES,
} from '@packages/systems/users/constants';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {Atom} from '@packages/systems/wfdl';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const UserResetPasswordForm = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild, context}) => {
    const props = generateAttributes(attributes, classes);
    const displayProps =
      context.get('formState') === 'success'
        ? {
            ...props,
            style: setDisplayNone(props.style),
          }
        : props;

    return (
      <form
        {...displayProps}
        method="post"
        {...{[USYS_DATA_ATTRS.formType]: USYS_FORM_TYPES.resetPassword}}
      >
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </form>
    );
  }
);

const config = createIntegratedAtom({
  constraints: {
    ancestors: [{is: 'UserResetPasswordFormWrapper', rule: 'ExactlyOne'}],
    page: [UsysUtilityPageConstraint],
    descendants: [
      {
        is: 'UserFormEmailInput',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserFormButton',
        rule: 'ExactlyOne',
      },
    ],
    pinToParent: true,
  },
  displayName: 'Reset Password Form',
  render: UserResetPasswordForm,
  showEmpty: true,
  fields: {
    children: TListOfElement,
  },
});

export default config;
